import { APICfg } from 'services/api/api'
import { CouponToAPI } from './types/api/request-models'
import { APICoupon } from './types/api/response-models'
import { Coupon } from './types/internal/coupon-models'

const apiCfg: APICfg = {
  endpoint: 'coupon',
  parse: (res: APICoupon): Coupon => res,
  write: async (req: Coupon): Promise<CouponToAPI> => req,
}

export default apiCfg
